import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import Navbar from '../components/NavbarDashboard';
import Footer from '../components/Footer';
import DemoFormContainer from '../components/DemoForm';
import GeneralConfigurationContainer from '../components/GeneralConfiguration';
import { useProfile } from '../api/hooks/profile';

function MainLayout({children, className = 'py-5', banner, footer = true, showUpgradeBanner = true, paddingBottom = 140}) { 

  return (
    <>
      <Navbar banner={banner} />
      {showUpgradeBanner && <UpgradePlanBanner /> }
      <section className={`bg-grey ${className}`} style={{paddingBottom}}> 
       {children}
      </section>  
      <GeneralConfigurationContainer />
      { footer && <Footer /> }
    </>
  )
}

function UpgradePlanBanner() {
  const { t } = useTranslation();
  const { profile } = useProfile();
  const planType = profile?.plan?.type !== 'free' ? 'premium' : 'free'

  return (
    <div className="w-100 bg-yellow text-accent text-center p-3 d-flex justify-content-center">
      <div className="font-weight-bold font-size-20">{t(`planBanner.${planType}`)}</div>{'   '}
      { planType === 'premium' ?
        <DemoFormContainer linkProps={{className: "text-underline ml-3 font-size-20"}} asLink>{t('actions.requestDemo')}</DemoFormContainer> : 
        <Link className="text-underline ml-3 font-size-20" to="/plans/monthly">{t('actions.upgradePlan')}</Link>
      }
    </div>
  )
}

MainLayout.propTypes = {
  children: PropTypes.element.isRequired,
}

export default MainLayout

